import React, { createContext, useContext, useEffect, useState } from 'react';

//Helpers
import { setSessionCookie, removeAllCookies, getSessionCookie } from '../helpers/cookies';

//API
import prefeitura_api from '../api/prefeitura_api';
import { showMessage } from 'helpers/message';

function initialContext() {
    return {
        loading: false,
        isSignout: false,
        session: null
    }
}

export const AuthContext = createContext(initialContext());

const AuthProvider = ({ children }) => {
    //Estados de autenticação
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useState(null);
    const [logoTipo, setLogoTipo] = useState(null);

    //Função que faz o controle de signIn
    const signIn = async (data) => {
        await setSessionCookie(data);
        setSession(data)
    }

    const signOut = async (token) => {
        if (!token)
            removeAllCookies();
        setSession(null);
    }

    const loadAsync = async () => {
        try {
            const data = await getSessionCookie();
            setSession(data);
        } catch (e) {
            setLoading(false);
        }
    };

    const logoTipoPrefeitura = () => {
        setLoading(true)
        prefeitura_api.getLogotipo()
            .then(response => setLogoTipo(response))
            .catch(_ => showMessage("Erro", "Erro na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadAsync();
        logoTipoPrefeitura();
    }, [])

    return (
        <AuthContext.Provider value={{
            session,
            loading,
            setLoading,
            signIn,
            signOut,
            logoTipo
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context;
}

export default AuthProvider;